import React from 'react';
import { isUndefined, eq } from 'lodash';
import { useLocation } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import MeasurePageSettings from './measurePageSettings';
import HomepageSettings from './homepageSettings';
import PlanNodePageSettings from './planNodePageSettings';
import { PAGE_DATA } from '../../../graphqls';

export default function PageSettings() {
  const { pathname } = useLocation();
  const paths = pathname.split('/');
  const {
    loading: loadingPageData,
    data: {
      pageData: {
        cache: {
          title,
          measures,
        } = {},
      } = {},
    } = {},
  } = useQuery(PAGE_DATA, { variables: { name: eq(paths[1], 'home') ? 'home' : paths[2] } });

  if (eq(loadingPageData, true)) {
    return '';
  }

  let settingPage;

  if (isUndefined(title)) {
    settingPage = (<HomepageSettings />);
  } else if (!isUndefined(measures)) {
    settingPage = (<PlanNodePageSettings />);
  } else {
    settingPage = (<MeasurePageSettings />);
  }

  return (
    <div className="layout-settings">
      <div className="page-setting-container">
        {settingPage}
      </div>
    </div>
  );
}
